import React from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

// Mirrors backend Order::STATUSES.
export const ORDER_STATUS_META = {
    pending:             { color: 'warning', labelEn: 'Pending',             labelAr: 'قيد الانتظار' },
    confirmed:           { color: 'info',    labelEn: 'Confirmed',           labelAr: 'مؤكد' },
    processing:          { color: 'info',    labelEn: 'Processing',          labelAr: 'قيد المعالجة' },
    shipped:             { color: 'primary', labelEn: 'Shipped',             labelAr: 'تم الشحن' },
    delivered:           { color: 'success', labelEn: 'Delivered',           labelAr: 'تم التسليم' },
    cancelled:           { color: 'default', labelEn: 'Cancelled',           labelAr: 'ملغي' },
    refunded:            { color: 'success', labelEn: 'Refunded',            labelAr: 'مسترد' },
    partially_refunded:  { color: 'warning', labelEn: 'Partially Refunded',  labelAr: 'مسترد جزئياً' },
    failed:              { color: 'error',   labelEn: 'Failed',              labelAr: 'فشل' },
};

export const ORDER_STATUS_OPTIONS = Object.entries(ORDER_STATUS_META).map(
    ([value, m]) => ({ value, label: { ar: m.labelAr, en: m.labelEn } })
);

const OrderStatusBadge = ({ status, sx }) => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');

    const meta = ORDER_STATUS_META[status] || {
        color: 'default',
        labelEn: status || '-',
        labelAr: status || '-',
    };

    return (
        <Chip
            label={isArabic ? meta.labelAr : meta.labelEn}
            size="small"
            color={meta.color}
            variant="tonal"
            sx={{ fontWeight: 'bold', borderRadius: '6px', minWidth: '90px', ...sx }}
        />
    );
};

export default OrderStatusBadge;
